<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">个人申报明细报表</li>
      <el-button
        type="primary"
        :icon="Upload"
        size="small"
        link
        @click="onExport"
        v-if="$judge_auth('611')"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="员工姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-date-picker
        v-model="state.tax_month"
        type="monthrange"
        placeholder="税款所属期"
        value-format="YYYY-MM"
        format="YYYY年M月"
        :clearable="false"
        style="width: 300px; flex-grow: 0"
      />
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.customer_id"
        placeholder="客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item"
          :value="item.id"
          :label="item.name"
        ></el-option>
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-select
        v-model="state.params.declare_item"
        placeholder="所得项目"
        style="width: 240px"
      >
        <el-option
          v-for="item in state.incomeData"
          :key="item.id"
          :label="item.value"
          :value="item.value"
        />
        <template #footer>
          <el-button size="small" @click="onLoadIncome()">刷新</el-button>
        </template>
      </el-select>
      <c_statusradiogroup
        v-model="state.params.declare_type"
        arrName="taxdeclare_declare_type"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          fixed
          label="姓名"
          prop="name"
          width="120"
          sortable="name"
          align="center"
        />
        <el-table-column
          :prop="item.field"
          :label="item.name"
          v-for="item in state.sortFields?.filter(
            (w) => !['name'].includes(w.field),
          )"
          :key="item"
          :width="180"
          align="center"
        >
          <template #header>
            <text :title="item.name">{{ item.name }}</text>
          </template>
          <template #default="{ row }">
            <div
              v-if="
                item.field
                  .split('.')
                  .reduce(
                    (acc, key) =>
                      acc && acc[key] !== undefined ? acc[key] : '-',
                    row,
                  )
              "
            >
              {{
                item.field
                  .split(".")
                  .reduce(
                    (acc, key) =>
                      acc && acc[key] !== undefined ? acc[key] : "-",
                    row,
                  )
              }}
            </div>
            <text v-else>-</text>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  taxdeclarereportemployee_list,
  taxdeclarereportemployee_export,
} from "@/http/taxdeclarereportemployee";
import { dayjs, ElMessage } from "element-plus";
import { income_select } from "@/http/dictionary";
import { data_customer_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive({
      ...new InitFormData(),
      tableData: [],
    });
    onMounted(() => {
      state.tax_month = [
        dayjs().subtract(1, "month").format("YYYY-MM"),
        dayjs().subtract(1, "month").format("YYYY-MM"),
      ];
      onLoadIncome();
      onLoadCustomer();
      // onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      if (state.tax_month?.length > 0)
        state.params.tax_month = state.tax_month.join(" - ");
      else delete state.params.tax_month;

      taxdeclarereportemployee_list(state.params)
        .then((res) => {
          if (res.status == 200) {
            const { count, list, sortFields } = res.data.data;
            state.totalCount = count;
            state.tableData = list;
            state.sortFields = sortFields;
          } else {
            state.totalCount = 0;
            state.tableData = [];
            ElMessage.error(res.data.msg);
          }
        })
        .catch((err) => {
          state.totalCount = 0;
          state.tableData = [];
          ElMessage.error(err.data.msg);
        });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");
      onLoad();
    };

    //获取所得项目
    const onLoadIncome = () => {
      income_select().then((res) => {
        if (res.status == 200) state.incomeData = res.data.data;
      });
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      taxdeclarereportemployee_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onExport,
      onLoadIncome,
      onLoadCustomer,
    };
  },
};
</script>
<style scoped></style>
